import React from 'react';
import styled from 'styled-components';
import logo from '../../assets/logo.png';
import hidev_logo from '../../assets/hidev_logo.png';

const FooterContainer = styled.footer`
  background-color: var(--primary);
  padding: var(--spacing-xl) 0;
  border-top: 1px solid var(--accent-1);
`;

const FooterContent = styled.div`
  max-width: var(--container-width);
  margin: 0 auto;
  padding: 0 var(--spacing-md);
  
  @media (min-width: 768px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 0 var(--spacing-lg);
  }
`;

const FooterLogo = styled.div`
  padding: var(--spacing-xs);
  margin-bottom: var(--spacing-lg);
  
  img {
    height: 60px;
    display: block;
  }
  
  @media (min-width: 768px) {
    margin-bottom: 0;
  }
`;

const FooterLinks = styled.div`
  @media (min-width: 768px) {
    display: flex;
    justify-content: center;
  }
  
  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--spacing-lg);
    margin-bottom: var(--spacing-xl);
  }
`;

const LinkColumn = styled.div`
  @media (min-width: 768px) {
    margin: 0 var(--spacing-lg);
  }
`;

const LinkHeading = styled.h4`
  font-size: 1.125rem;
  margin-bottom: var(--spacing-md);
  color: var(--secondary);
`;

const LinkList = styled.ul`
  li {
    margin-bottom: var(--spacing-sm);
  }
  
  a {
    color: var(--secondary);
    font-size: 0.875rem;
    transition: color 0.3s ease;
    
    &:hover {
      color: var(--accent-2);
    }
  }
`;

const HidevLogo = styled.a`
  img {
    height: 50px;
    display: block;
  }
  
  @media (max-width: 768px) {
    margin-top: var(--spacing-lg);
  }
`;

const Copyright = styled.div`
  text-align: center;
  margin-top: var(--spacing-xl);
  padding-top: var(--spacing-lg);
  padding-left: var(--spacing-md);
  padding-right: var(--spacing-md);
  border-top: 1px solid var(--accent-1);
  color: var(--secondary);
  font-size: 0.875rem;
  
  @media (max-width: 768px) {
    padding-left: var(--spacing-xl);
    padding-right: var(--spacing-xl);
  }
  
  a {
    color: var(--secondary);
    text-decoration: none;
    transition: color 0.3s ease;
    
    &:hover {
      color: var(--accent-2);
    }
  }
`;

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <FooterContent>
        <FooterLogo>
          <img src={logo} alt="GS Autohaus Logo" />
        </FooterLogo>

        <FooterLinks>
          <LinkColumn>
            <LinkHeading>Quick Links</LinkHeading>
            <LinkList>
              <li><a href="#home">Home</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#contact">Contact</a></li>
            </LinkList>
          </LinkColumn>

          <LinkColumn>
            <LinkHeading>Services</LinkHeading>
            <LinkList>
              <li><a href="#services">European & Japanese Auto Service</a></li>
              <li><a href="#services">Mechanical & Electrical Diagnostics</a></li>
              <li><a href="#services">Programming & Encoding</a></li>
              <li><a href="#services">Engine Rebuilding & Performance</a></li>
              <li><a href="#services">Vehicle Modifications</a></li>
              <li><a href="#services">JDM & Classic Vehicles</a></li>
              <li><a href="#services">Auto Glass Services</a></li>
            </LinkList>
          </LinkColumn>
        </FooterLinks>

        <HidevLogo href="https://hidevmobile.com" target="_blank" rel="noopener noreferrer">
          <img src={hidev_logo} alt="HiDev Logo" />
        </HidevLogo>
      </FooterContent>

      <Copyright>
        &copy; {currentYear} GS Autohaus. All rights reserved. | <a href="#">Privacy Policy</a> | <a href="#">Terms of Service</a>
      </Copyright>
    </FooterContainer>
  );
};

export default Footer; 